"use strict";
Object.defineProperty(exports, "__esModule", {
  value: true
});
const tokens = {"rotating":"CircularProgress_3l7vo","vlm-circular-progress-rotating":"CircularProgress_35J4n"};
tokens._getCss = function () {return `/* imported from CircularProgress.css */ @keyframes CircularProgress_35J4n { from { transform: rotate(0deg); } to { transform: rotate(360deg); } } .CircularProgress_3l7vo { animation: CircularProgress_35J4n 550ms linear infinite; } `;};
tokens._module = (typeof module !== "undefined") ? module : {id:"./common/src/svg/sync/CircularProgress_css.js"};
exports["default"] = tokens;